export default {
  name: "NewPasswordSuccess",
  path: "success",
  component: () => import("@/views/NewPassword/Success")
};
